import { MultipleColorsIconProps } from "typing";
import { theme } from "../themes";

export const TrackingStatusDeliveryManAtPlace = ({
  width = 36,
  height = 32,
  color = theme.colors.secondary["380"],
  secondColor = theme.colors.neutral.white,
  alt = "Entregador no local de entrega",
}: MultipleColorsIconProps) => {
  return (
    <svg
      aria-label={alt}
      width={width}
      height={height}
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.2801 11.5884C33.7503 13.015 33.993 14.5026 34 16C34 24.2843 27.0604 31 18.5 31C9.93959 31 3 24.2843 3 16C3 7.71573 9.93959 1 18.5 1C20.0473 1.00676 21.5845 1.24168 23.0587 1.69666"
        fill={secondColor}
      />
      <path
        d="M33.2801 11.5884C33.7503 13.015 33.993 14.5026 34 16C34 24.2843 27.0604 31 18.5 31C9.93959 31 3 24.2843 3 16C3 7.71573 9.93959 1 18.5 1C20.0473 1.00676 21.5845 1.24168 23.0587 1.69666"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.7002 5.36442L28.5018 7.11442L31.5002 4.19775"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8527 15.7321C15.2895 15.7321 15.666 14.4757 16.269 13.9C16.3535 13.8193 16.2779 13.8897 16.3642 13.8205C16.9677 13.337 17.2963 13.2576 18.0849 13.1678C18.6738 13.1007 19.3886 13.3943 19.8544 13.7342C20.6785 14.3358 21.0192 15.7321 20.4541 15.7321C20.0344 15.7321 20.4206 15.0477 19.7137 14.3012C19.6331 14.2161 19.5231 14.1464 19.4183 14.0722C19.2898 13.9814 19.2026 13.937 19.054 13.8671C18.2336 13.4809 17.1301 13.7349 16.5931 14.3012C15.8933 15.0392 16.3093 15.7321 15.8527 15.7321ZM17.0031 11.1725C17.0031 9.55681 19.3038 9.5454 19.3038 11.1725C19.3038 11.4441 19.1215 11.7323 18.9692 11.8795C18.2451 12.5794 17.0031 12.0746 17.0031 11.1725ZM16.2067 9.66694C16.2067 10.0053 15.5283 10.3777 15.8527 11.7317C14.1604 11.8686 14.4507 13.4931 14.4387 14.4433C14.4352 14.7158 14.3791 15.1032 14.3361 15.376C14.156 16.5189 13.7733 16.9147 13.7733 18.1409C13.7733 19.3351 14.4891 20.616 15.3403 21.263C16.3138 22.0031 16.0297 21.6143 16.0297 21.367C16.0297 20.1124 15.9372 18.94 17.3872 18.3423C18.3323 17.9528 19.5159 18.3647 20.0421 19.3157C20.3639 19.8973 20.2771 20.8385 20.2771 21.7111C21.7162 20.9708 22.5336 19.5416 22.5336 17.8828C22.5336 16.6806 21.8599 16.0437 21.8693 14.4422C21.8731 13.7991 21.943 13.0148 21.7237 12.562C21.4977 12.0955 21.0849 11.7827 20.4541 11.7317C20.6827 10.7777 20.457 10.447 20.0559 9.70995L20.7008 8.74537C20.9182 8.45172 20.8754 8.37165 21.3371 8.37467C21.8562 8.37807 23.2857 8.57872 23.2857 7.68825C23.2857 7.29949 22.9777 7 22.5778 7H20.4099C20.1453 7 19.9043 7.43226 19.702 7.73126C19.6035 7.8768 19.2032 8.50553 19.0383 8.50553C16.7231 8.50553 17.2897 8.70522 16.5539 7.73778C16.4479 7.59833 16.3633 7.47732 16.2575 7.33779C15.942 6.9221 15.9237 7.05693 15.0978 7.04373C14.9787 7.04182 14.8368 7.02936 14.7975 7.02991C14.1104 7.03966 13.4333 6.94997 13.1641 7.26812C12.9141 7.56374 12.9578 8.02627 13.2404 8.24931C13.5191 8.46924 14.0214 8.41955 14.5254 8.4195C15.5361 8.4194 15.2193 8.36516 15.897 9.23679C15.9303 9.27972 16.2067 9.64472 16.2067 9.66694Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6489 20.1197V22.7436C16.6489 23.5068 17.3652 24.1631 18.1532 24.1631C18.9412 24.1631 19.6575 23.5068 19.6575 22.7436V20.1197C19.6575 19.3617 18.9254 18.7002 18.1532 18.7002C17.3811 18.7002 16.6489 19.3617 16.6489 20.1197Z"
        fill={color}
      />
    </svg>
  );
};
